export const MiniSiteConstants = {
  ADMIN_DATE_SELECTOR: "adminDateSelector",
};

export const PaymentActivationMode = {
  ENABLE: "enable",
  ENROLL: "enroll",
  DISENROLL: "disenroll",
};
